export const faqs = [
  {
    id: "faq-1",
    question: "Apakah CV Angkasa Briliant melayani perusahaan?",
    answer:
      "Ya. Layanan kami diarahkan untuk kebutuhan perusahaan, gedung, dan fasilitas komersial, termasuk perkantoran, hotel, restoran, property, dan fasilitas lainnya.",
  },
  {
    id: "faq-2",
    question: "Apakah tersedia kontrak maintenance?",
    answer:
      "Ya. Kami menyediakan program maintenance berkala (Maintenance Contract) untuk perusahaan yang membutuhkan perawatan AC & HVAC secara rutin dan terencana.",
  },
  {
    id: "faq-3",
    question: "Apakah bisa melakukan survey?",
    answer:
      "Bisa. Kami dapat melakukan survey lokasi dan assessment untuk memeriksa kondisi unit dan kebutuhan maintenance sebelum menentukan layanan dan penawaran.",
  },
  {
    id: "faq-4",
    question: "Area mana yang dilayani?",
    answer:
      "Kami fokus melayani kebutuhan AC & HVAC di Makassar dan area layanan yang dapat dijangkau.",
  },
  {
    id: "faq-5",
    question: "Bagaimana cara mendapatkan penawaran?",
    answer:
      "Anda dapat menghubungi kami melalui WhatsApp atau mengisi formulir permintaan penawaran di halaman ini. Tim kami akan menindaklanjuti untuk membahas kebutuhan maintenance Anda.",
  },
];

export default faqs;
